export default {
	created: function() {
		document.addEventListener("scroll", this.scrollFollow)
	},
	destroyed: function() {
		document.removeEventListener("scroll", this.scrollFollow)
	},
	methods: {
		scrollFollow: function(e) {
			if(this.$refs.scrollableSummary) {
				this.$refs.scrollableSummary.$el.style.top = (e.target.scrollingElement.scrollTop + 85)+"px";
			}
		}
	}
}